import React from "react";
import style from "./style.module.css";
import PropTypes from "prop-types";
import { Button, NoComponent } from "views/components";
import EllipsisIcon from "views/components/icons/EllipsisIcon";
import { Logger, noop } from "lib";
import composeClassName from "lib/composeClassName";
import useMobile from "views/components/Editor/mobile/useMobile";
import MobileDesignActionSheet from "views/containers/DesignsPageContainer/Workspace/mobile/MobileDesignActionSheet";

const IconButton = ({
  iconColor = "#9a9b9d",
  Icon = NoComponent,
  title,
  className,
  iconSize = "20",
  iconBoxSize,
  onClick = noop,
  MenuComponent,
  showMenu,
  setMenuState,
  titleClassName,
  isDisabled,
  wrapperClassName,
  theme,
  iconClassName
}) => {
  const isMobile = useMobile();
  const showMobileUI = isMobile;

  if (!iconBoxSize) iconBoxSize = iconSize;
  if (!Icon) {
    Logger.error(
      "No Icon Provided. Please provide an Icon or use Button Component"
    );
    return null;
  }

  const getButtonClassName = () => {
    const classes = [style.button];

    if (className) {
      classes.push(className);
    }

    return classes.join(" ");
  };

  const onToggleMenuClick = event => {
    event.preventDefault();
    event.stopPropagation();

    setMenuState(!showMenu);
  };

  return (
    <div
      className={[style.wrapper, wrapperClassName].filter(x => x).join(" ")}
      data-testid="IconButton"
    >
      <Button
        className={getButtonClassName()}
        onClick={onClick}
        disabled={isDisabled}
        theme={theme}
      >
        <div
          className={`${style.icon} ${iconClassName}`}
          style={{ width: `${iconBoxSize}px`, height: `${iconBoxSize}px` }}
        >
          <Icon color={iconColor} size={iconSize} />
        </div>
        {title && (
          <div
            className={composeClassName("title", style, titleClassName)}
            data-testid="iconButtonTitle"
          >
            {title}
          </div>
        )}
        {MenuComponent && (
          <div
            className={style.menu}
            data-is-active={showMenu}
            onClick={onToggleMenuClick}
          >
            <EllipsisIcon
              color="#999c9e"
              withBackground={true}
              backgroundColor="transparent"
            />
          </div>
        )}
      </Button>
      {showMenu && !showMobileUI && MenuComponent}
      {showMenu && showMobileUI && (
        <MobileDesignActionSheet
          isOpen={showMenu}
          onClose={() => setMenuState(false)}
        >
          {MenuComponent}
        </MobileDesignActionSheet>
      )}
    </div>
  );
};

IconButton.displayName = "IconButton";

IconButton.propTypes = {
  Icon: PropTypes.oneOfType([PropTypes.element, PropTypes.func]).isRequired,
  MenuComponent: PropTypes.element,
  className: PropTypes.string,
  iconColor: PropTypes.string,
  onClick: PropTypes.func,
  setMenuState: PropTypes.func,
  showMenu: PropTypes.bool,
  title: PropTypes.node
};

export default IconButton;
